import type { SelectRouterItem } from '@/types'
import { routeNames } from '@/router/route-names.ts'
import { uriRoles } from '@/router/uri-roles.ts'

export const pmSelectedRouterList: SelectRouterItem[] = [
  {
    value: 1,
    title: 'Danh mục dự án',
    name: routeNames.ProjectList,
    routeName: routeNames.ProjectList,
    uriRole: uriRoles.ProjectList,
    disabled: false,
  },
  {
    value: 2,
    title: 'Kế hoạch tài chính năm',
    name: routeNames.ProjectAccountingYearReport,
    routeName: routeNames.ProjectAccountingYearReport,
    uriRole: uriRoles.ProjectAccountingYearReport,
    disabled: false,
  },
  {
    value: 3,
    title: 'Thẩm định hồ sơ',
    name: routeNames.ProjectAppraisal,
    routeName: routeNames.ProjectAppraisal,
    uriRole: uriRoles.ProjectAppraisal,
    disabled: false,
  },
  {
    value: 4,
    title: 'Chu kỳ cảnh báo',
    name: routeNames.ProjectAggregationCycle,
    routeName: routeNames.ProjectAggregationCycle,
    uriRole: uriRoles.ProjectAggregationCycle,
    disabled: false,
  },
  {
    value: 5,
    title: 'Dự thảo kế hoạch đầu tư',
    name: routeNames.DraftProject,
    routeName: routeNames.DraftProject,
    uriRole: uriRoles.DraftProjectSearch,
    disabled: false,
  },
]
